import { applyMiddleware, createStore } from 'redux'
import { routerMiddleware } from 'react-router-redux'

import history from './history'
import reducers from '../reducers'

const middleware = applyMiddleware(routerMiddleware(history))

export default createStore(reducers, middleware)



// WEBPACK FOOTER //
// ./src/store/index.js